export default __webpack_public_path__ + "static/media/define-the-fields-in-an-entity.5509f157.svg";